module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-19.9dddf470.png";